<div class="btn-toolbar btn-toolbar-primary">
    <div class="btn-group">
        <button
            type="button"
            class="btn"
            [ngClass]="{ active: value === 1, transparent: disableLowPriority }"
            (click)="select(1)"
            [disabled]="disableLowPriority"
        >
            <app-tooltip
                class="btn-tooltip"
                [compact]="true"
            >
                <ng-container icon>
                    {{ 'LOW_PRIORITY_BUTTON' | translate }}
                </ng-container>
            </app-tooltip>
        </button>

        <button type="button" class="btn" [ngClass]="{ active: value === 2 }" (click)="select(2)">
            {{ 'MEDIUM_PRIORITY_BUTTON' | translate }}
        </button>
        <button
            type="button"
            class="btn"
            [ngClass]="{ active: value === 3, transparent: disableHighPriority }"
            (click)="select(3)"
            [disabled]="disableHighPriority"
        >
            <app-tooltip
                class="btn-tooltip"
                [compact]="true"
            >
                <ng-container icon>
                    {{ 'HIGH_PRIORITY_BUTTON' | translate }}
                </ng-container>
            </app-tooltip>
        </button>
        <button
            type="button"
            class="btn"
            [ngClass]="{ active: value === 6, transparent: disableCriticalPriority }"
            (click)="select(6)"
            [disabled]="disableCriticalPriority"
        >
            <app-tooltip
                class="btn-tooltip"
                [compact]="true"
            >
                <ng-container icon>
                    {{ 'CRITICAL_PRIORITY_BUTTON' | translate }}
                </ng-container>
            </app-tooltip>
        </button>
    </div>
</div>
